import SortService from '@/services/sort.service'
import axios from 'axios'
import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        loadingLeads: false,
        leadsIsLoad: false,
        currentPage: localStorage.getItem('currentLeadPage') ? +localStorage.getItem('currentLeadPage') : 1,
        leads: [],
        selectedPool: [],
        totalCount: 0
    },
    mutations: {
        SET_CURRENT_PAGE(state, page_number) {
            state.currentPage = page_number;
            localStorage.setItem('currentLeadPage', page_number);
        },
        SET_LOADING_LEADS(state, loading) {
            state.loadingLeads = loading;
        },
        SET_TOTAL_COUNT(state, totalCount) {
            state.totalCount = totalCount;
        },
        SET_LEADS_IS_LOAD(state, load) {
            state.leadsIsLoad = load;
        },
        SET_LEADS(state, leads) {
            state.leads = leads;
        },
        SET_SELECTED_POOL(state, selectedPool) {
            state.selectedPool = selectedPool;
        },
        REALTIME_CREATE_LEAD(state, lead) {
            state.leads.unshift(lead);
        },
        REALTIME_UPDATE_LEAD(state, { lead, index }) {
            state.leads[index] = lead;
            Vue.set(state.leads, index, state.leads[index]);
        },
        SOCKET_DELETE_LEAD(state, lead_id) {
            const index = state.leads.findIndex(lead => lead.id === lead_id);
            state.leads.splice(index, 1);
        }
    },
    getters: {
        leads: (state) => state.loadingLeads === false ? state.leads : [],
        loadingLeads: (state) => state.loadingLeads,
        leadsIsLoad: (state) => state.leadsIsLoad,
        currentPage: (state) => state.currentPage,
        selectedPool: (state) => state.selectedPool,
        totalCount: (state) => state.totalCount,
    },
    actions: {
        loadLeads({ commit }, { type, user_id }) {
            commit("SET_LOADING_LEADS", true);
            // commit("SET_CURRENT_PAGE", 1);

            axios.get(`lead/all/${type}/${user_id}`)
                .then((res) => {
                    commit("SET_LEADS", SortService.sortLeads(res.data.leads));
                    commit("SET_LEADS_IS_LOAD", true);
                    commit("SET_LOADING_LEADS", false);
                })
                .catch((e) => {
                    console.log(e);
                    commit("SET_LOADING_LEADS", false);
                })
        },
        loadGuideLeads({ commit }) {
            axios.get(`lead/guide/all`)
                .then(res => {
                    commit("SET_LEADS", SortService.sortLeads(res.data.leads));
                    commit("SET_LOADING_LEADS", false);
                })
                .catch(e => {
                    console.log(e);
                    commit("SET_LOADING_LEADS", false);
                })
        },
        loadLeadsBySource({ commit }, source) {
            axios.get(`lead/all/${source}`)
                .then(res => {
                    commit("SET_LEADS", SortService.sortLeads(res.data.leads));
                    commit("SET_LOADING_LEADS", false);
                })
                .catch(e => {
                    console.log(e);
                    commit("SET_LOADING_LEADS", false);
                })
        },
        loadLeadsByFilters({ commit }, { params, search, page = 1, limit = 10 }) {
            commit("SET_LOADING_LEADS", true);
            // commit("SET_CURRENT_PAGE", 1); 
            axios.post('lead/filter', { params, search, limit, page })
                .then((res) => {
                    commit("SET_CURRENT_PAGE", page);
                    commit("SET_LEADS", SortService.sortLeads(res.data.leads));
                    commit("SET_TOTAL_COUNT", res.data.totalCount);
                    // commit("SET_LEADS_IS_LOAD", true);
                    commit("SET_LOADING_LEADS", false);
                })
                .catch((e) => {
                    console.log(e);
                    commit("SET_LOADING_LEADS", false);
                });
        },
        loadLeadsBySearch({ commit }, { filterParams, searchParams, page = 1, limit = 10 }) {
            commit("SET_LOADING_LEADS", true);
            axios.post("lead/getFromSearch", { filterParams, searchParams, limit, page })
                .then((res) => {
                    commit("SET_CURRENT_PAGE", page);
                    commit("SET_LEADS", SortService.sortLeads(res.data.response.leads));
                    commit("SET_TOTAL_COUNT", res.data.response.totalCount);
                    commit("SET_LOADING_LEADS", false);
                })
                .catch(e => {
                    console.log(e);
                    commit("SET_LOADING_LEADS", false);
                })
        },
        "SOCKET_CREATE_LEAD"({ commit }, data) {
            const sortedLead = data.type_id === 2 ? SortService.sortLead(data) : SortService.sortHealthLead(data);

            commit("REALTIME_CREATE_LEAD", sortedLead);
        },
        "SOCKET_UPDATE_LEADS"({ commit, state }, data) {
            const sortedLead = data.type_id === 2 ? SortService.sortLead(data) : SortService.sortHealthLead(data);
            const index = state.leads.findIndex(lead => lead.id === sortedLead.id);

            commit("REALTIME_UPDATE_LEAD", {
                lead: sortedLead,
                index
            })
        }
    },
}
